export const contentMapping = (content, trsMode) => {
  if (content && trsMode) {
    const myObj = { ...content }

    const replacementsList = [
      'pv_package_title',
      'pv_package_cta_choose',
      'pv_title_1',
      'pv_title_2',
      'pv_title_3',
      'pv_package_information_title_selectedoffer',
      'pv_package_information_title_singleoffer',
      'pv_package_information_title',
      'pv_package_information_text1',
      'pv_package_information_text1_singleoffer',
      'pv_package_information_text1_singleoffer_no_sunsure',
      'pv_package_information_text2',
      'pv_cta_choose_text',
      'pv_contactblock_text',
      'pv_package_savingsyear1',
    ]

    replacementsList.forEach((el) => {
      myObj[el] = content[`trs_${el}`]
    })
    return myObj
  }
  return content
}

export default contentMapping
